import { toast } from "react-toastify";
import { auth, UserFormData, LoginSuccessResponse, LoginFailResponse } from "../Services/LoginService.ts";

export const handleLogin = async (
    userformData: UserFormData
  ): Promise<LoginSuccessResponse | undefined> => {
    try {
      const response = await auth.login(userformData);
  
      if (response.status === 200) {
        return response.data as LoginSuccessResponse;
      }
    } catch (error: any) {
      throw new Error(
        error.response?.data?.error?.message || "Login failed. Please try again."
      );
    }
  };
  
  
  
export const handleSignIn = async (username, navigate, setLoading) => {
  try {

    const response = await auth.signIn(username);

    if (response) {
      localStorage.setItem("environment", response?.data?.rbac);
      localStorage.setItem("isSSO", response?.data?.isSSOUser);

      if (response?.data?.rbac === "Keycloak") {        
        // Clear any existing session data
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('userName');
        
        // Build Keycloak login URL

        const redirectUri = `${window.location.origin}/keycloak/callback`;
        
        // Generate PKCE parameters
        const state = generateRandomString(32);
        const codeVerifier = generateCodeVerifier();
        const codeChallenge = await generateCodeChallenge(codeVerifier);
        
        // Store PKCE verifier for token exchange
        sessionStorage.setItem('pkce_code_verifier', codeVerifier);
        sessionStorage.setItem('keycloak_state', state);
        
        // Construct the login URL
        const params = new URLSearchParams({
          client_id: window.env.REACT_APP_KEYCLOAK_CLIENT_ID,
          redirect_uri: redirectUri,
          state: state,
          response_mode: 'query',
          response_type: 'code',
          scope: 'openid profile email',
          code_challenge: codeChallenge,
          code_challenge_method: 'S256',
          login_hint: username,
        });
        
        const loginUrl = `${window.env.REACT_APP_KEYCLOAK_URL}/realms/${window.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth?${params.toString()}`;
        
        window.location.href = loginUrl;
        return;
      }
      
      // Handle SSO (Azure/Google)
      if (response?.data?.isSSOUser) {
        window.location.href = response?.data?.redirectURL; // FIXED
      } else {
        navigate(`/login/${username}`, {
          state: {
            signIn: response.data,
          },
        });
        setLoading(false)
      }
    }
  } catch (error) {
    toast.error(error?.message || "Something went wrong");
    setLoading(false)
  }
};

// Helper functions for PKCE
function generateRandomString(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
  }
  return result;
}

function generateCodeVerifier() {
  return generateRandomString(128);
}

async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(hash);
}

function base64UrlEncode(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}
